import React from 'react';
import { block } from 'bem-cn';

import { URL_OF_ICONS_WEB_FOLDER_S3_BUCKET } from '../../constants';
import Typography from '../Typography';

import './suggested-action-plate.scss';

const b = block('suggested-action-plate');

export type SuggestedActionPlateType = {
  id: string;
  title: string;
  icon: string;
};

export declare type SuggestedActionPlatePropsType = {
  suggestedAction: SuggestedActionPlateType;
  onClick: (suggestedAction: any) => void;
};

const SuggestedActionPlate = ({
  suggestedAction,
  onClick,
}: SuggestedActionPlatePropsType) => {
  return (
    <div className={b()} onClick={onClick}>
      <div
        className={b('icon')}
        style={{
          backgroundImage: `url("${URL_OF_ICONS_WEB_FOLDER_S3_BUCKET}${suggestedAction.icon}.svg")`,
        }}
      />
      <div className={b('title')}>
        <Typography
          component='div'
          variant={Typography.THEME.VARIANTS.TITLE_MICRO}
        >
          {suggestedAction.title}
        </Typography>
      </div>
    </div>
  );
};

export default SuggestedActionPlate;
